import moment from "moment";
import { FunctionComponent, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import {
  useToast,
  ToastType,
} from "../../../../../context_providers/toast/toast_ctx";
import { fetchGet } from "../../../../../service/api_client";
import { UTCToLocalDate } from "../../../../../utils/date_util";
import WarehouseSearchField from "../../../warehouse/warehouse_search_field";
import { urls } from "../../../../../utils/urls";
import {
  stockJournalDefaultValue,
  StockJournalModel,
} from "../../../models/stock_transfer_model";
import ItemRowStockTransfer from "./ItemRowStockTransfer";
import { WarehouseModel } from "../../../models/warehouse_model";

interface StockJournalProps {}

const SenderStockTransferViewScreen: FunctionComponent<
  StockJournalProps
> = () => {
  const { id } = useParams<{ id: string }>();
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/journal/sender_transfer`;
  const [, setLoading] = useState(false);
  const { showToast } = useToast();
  const [availableItems, setAvailableItems] = useState([]);
  const [data, setData] = useState<StockJournalModel>({
    ...stockJournalDefaultValue,
  });
  const existingItems = data.source || [];
  const navigate = useHistory();

  useEffect(() => {
    if (id) getVoucher(id);
  }, [id]);

  const getVoucher = async (id: string) => {
    setLoading(true);
    const res = await fetchGet(url + "/" + id);
    if (res.success) {
      const newData = {
        ...res.data,
      };

      setData((prevData) => ({
        ...prevData,
        ...newData,
      }));
    } else {
      showToast({ type: ToastType.error, text: res.error });
    }

    setLoading(false);
  };

  const getItemsInSelectedWarehouse = async (warehouse: WarehouseModel) => {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/items/warehouses?warehouse_id=${warehouse.id}`;
    setLoading(true);

    try {
      const res = await fetchGet(url);
      if (res.success) {
        const { item_data } = res.data;

        setAvailableItems(item_data);
      } else {
        showToast({ type: ToastType.error, text: res.error });
        return null;
      }
    } catch (error) {
      showToast({
        type: ToastType.error,
        text: "An error occurred while fetching warehouse stock value",
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data.from_warehouse) {
      getItemsInSelectedWarehouse(data.from_warehouse);
    }
  }, [data.from_warehouse]);

  return (
    <>
      <div className="sticky top-0 mt-2 px-6 h-full">
        <div className="flex items-center justify-between mb-2">
          <div className="text-xl font-bold border-l-4 border-myPrimaryColor pl-2">
            Stock Transfer
          </div>
        </div>
        <div className="bg-white rounded mb-5 flex gap-1 h-auto overflow-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 p-5 text-sm w-3/4 font-semibold rounded-t top-0">
            <div className="">
              <div className="font-bold text-md mb-3">From</div>
              <div className="">
                {/* <div className="">
                  <div className="font-semibold my-1">Sender Name</div>
                  <input
                    value={
                      data.user?.first_name ??
                      (data.user?.first_name && data.user?.last_name
                        ? `${data.user.first_name} ${data.user.last_name}`
                        : undefined) ??
                      data.from_warehouse?.spoc?.contact_name
                    }
                    placeholder="Sender"
                    type="text"
                    disabled={!editable}
                    className="text-left p-1 border rounded-md focus:outline-none w-full"
                  />
                </div> */}

                {/* <div className="font-semibold my-1">Sender Department</div>
                <input
                  value={data.user?.emp_profile?.department ?? data.from_warehouse?.spoc?.department}
                  placeholder="Department"
                  disabled={!editable}
                  type="text"
                  className="text-left p-1 border rounded-md focus:outline-none w-full"
                /> */}
              </div>
              <div className="font-semibold my-1">From Warehouse</div>
              <WarehouseSearchField
                type={""}
                disabled={true}
                value={data.from_warehouse}
                placeholder="Inventory Basket"
                onSelect={(d) => {
                  setData((old) => {
                    return {
                      ...old,
                      from_warehouse: d,
                    };
                  });
                }}
              />
              <div className="">
                <label htmlFor="" className="font-semibold mt-1">
                  Shipment Date
                </label>{" "}
                <input
                  type="date"
                  disabled
                  className=" focus:outline-none focus:ring-2 ring-blue-400 rounded-md py-1 px-2 w-full text-sm border"
                  value={
                    data.shipment_date
                      ? moment(data.shipment_date).format("YYYY-MM-DD")
                      : ""
                  }
                  min={moment().format("YYYY-MM-DD")}
                  onChange={(e) => {
                    const date = UTCToLocalDate(e.target.value)!;
                    setData((o) => ({
                      ...o,
                      shipment_date: date,
                    }));
                  }}
                />
              </div>
              <div className="mt-1">
                <label htmlFor="" className="font-semibold w-full mt-1">
                  Purchase Order ID
                </label>
                <input
                  placeholder="Purchase Order ID"
                  disabled
                  className="p-1 rounded focus:outline-none w-full border"
                  id="purchase_order_id"
                  name="purchase_order_id"
                  value={data?.purchase_order_id}
                />
              </div>
            </div>
            <div className="mr-0">
              <div className="font-bold text-md mb-3">To</div>

              <div className="font-semibold my-1">Warehouse/office</div>
              <WarehouseSearchField
                type={""}
                disabled={true}
                value={data.receiver_warehouse}
                placeholder="Inventory Basket"
                onSelect={(d) => {
                  setData((old) => {
                    return {
                      ...old,
                      receiver_warehouse: d,
                      //   department:d.spoc?.department,
                      //   contact_name:d.spoc?.contact_name
                    };
                  });
                }}
              />
              <div className="">
                <div className="font-semibold my-1">
                  Delivery Challan Number/Invoice
                </div>
                <input
                  value={data.delivery_challan_number}
                  disabled
                  name="challan"
                  id="challan"
                  placeholder="Delivery Challan"
                  type="text"
                  className="text-left p-1 focus:outline-none border rounded w-full"
                  onChange={(e) =>
                    setData((d) => ({
                      ...d,
                      delivery_challan_number: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="flex flex-col items-start text-sm w-full">
                <label className="font-semibold my-1" htmlFor="line1">
                  Tracking ID
                </label>
                <input
                  disabled
                  placeholder="track id"
                  className="p-1 rounded focus:outline-none w-full border"
                  id="track_id"
                  name="track_id"
                  value={data.tracking_id}
                  onChange={(e) =>
                    setData((prevData) => ({
                      ...prevData,
                      tracking_id: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="flex flex-col gap-1 w-full">
                <label htmlFor="" className="font-semibold mt-1">
                  Expected Received Date
                </label>{" "}
                <input
                  disabled
                  type="date"
                  required
                  className=" focus:outline-none focus:ring-2 ring-blue-400 rounded-md py-1 px-2 w-full text-sm border"
                  value={
                    data?.expected_received_date
                      ? moment(data?.expected_received_date).format(
                          "YYYY-MM-DD",
                        ) // Format to YYYY-MM-DD for input
                      : "" // Empty by default, so no date is selected initially
                  }
                  min={moment().format("YYYY-MM-DD")} // Prevent selection of past dates
                  onChange={(e) => {
                    const selectedDate = e.target.value; // Get the selected date string (YYYY-MM-DD)
                    const date = selectedDate
                      ? new Date(new Date(selectedDate).setHours(0, 0, 0, 0)) // Set the time to 00:00:00
                      : undefined; // If no date is selected, reset the value

                    // Update the state with the selected date
                    setData((pv) => ({
                      ...pv,
                      expected_received_date: date!, // Save the selected date in state
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 mt-5 ">
          <div className="flex flex-col gap-5">
            <div className="">
              <h3 className="text-sm font-bold">Particulars</h3>
              <div className="bg-white rounded flex flex-col gap-1 h-auto overflow-auto pb-20">
                <div className="grid grid-cols-7 gap-1 p-1 bg-myPrimaryColor text-white text-sm font-semibold rounded-t sticky top-0">
                  <div className="text-left">Item Code</div>
                  <div className="text-left col-span-2">Item Name</div>
                  <div className="text-left ">Unit Measure</div>
                  <div className="text-left">Qty</div>
                  <div className="text-left">Device IDs</div>
                  <div className="text-center"></div>
                </div>
                <div>
                  {data.source?.map((comp, i) => {
                    return (
                      <ItemRowStockTransfer
                        component={comp}
                        edit={false}
                        disabled={true}
                        key={comp.id}
                        onDelete={(d: any) => {
                          setData((o) => {
                            const sender = [
                              ...(o.source || []).filter(
                                (it) => it.id !== d.id,
                              ),
                            ];

                            return {
                              ...o,
                              sender,
                            };
                          });
                        }}
                        onSubmit={(d: any) => {
                          setData((o) => {
                            const sender = [
                              ...(o.source || []).map((it) =>
                                it.id === d.id ? d : it,
                              ),
                            ];

                            return {
                              ...o,
                              sender,
                            };
                          });
                        }}
                        existingItems={existingItems}
                        from_warehouse={data.from_warehouse!}
                        availableItems={availableItems}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex sticky bottom-0 justify-end my-5 gap-4 px-5 py-5">
        <button
          type="button"
          className="px-10 py-1 rounded-md bg-myPrimaryColor text-white text-sm"
          onClick={() => navigate.push(urls.stock_transfer)}
        >
          Quit
        </button>
      </div>
      {/* )} */}
    </>
  );
};

export default SenderStockTransferViewScreen;
